import {
  Vector3,
  Raycaster,
  Vector2,
} from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { config } from "./../config";
import nipplejs from "nipplejs";

const painting = require.context(
  "../../../static/img/paintings",
  true,
  /\.png$/
);
const YTPlayer = require("yt-player");

// vars
let fwdValue = 0;
let bkdValue = 0;
let rgtValue = 0;
let lftValue = 0;

let tempVector = new Vector3();
let upVector = new Vector3(0, 1, 0);

let joyManager;

export default class Orbit {
  constructor(viewer) {
    this.viewer = viewer;
    this.mouse = new Vector2();
    this.frontRay = new Raycaster();
    // this.textureFrame = new TextureLoader().load(Frame)
    this.player = new YTPlayer("#ytplayer");
    this.point = {};
    this.point2 = {};
    this.paintings = painting.keys().reduce((images, key) => {
      images[key] = painting(key);
      return images;
    }, {});
    this.init();
    this.addJoystick();
  }

  init() {

    this.orbit = new OrbitControls(
      this.viewer.camera,
      this.viewer.renderer.domElement
    );
    this.orbit.target = new Vector3(0, 1.7, 0);
    this.orbit.rotateSpeed = 0.6;
    this.orbit.enabled = false
    this.viewer.container.addEventListener("touchstart", (event) => {
      this.time = new Date().getTime();
      this.changedTouches = {
        x: event.changedTouches[0].clientX,
        y: event.changedTouches[0].clientY,
      };
    });

    this.viewer.container.addEventListener("touchend", this.onTouch.bind(this));
    document.getElementById("painting__close").addEventListener(
      "touchend",
      // "touchstart",
      () => {
        document.getElementById("popup-painting").classList.remove("active");
        document.getElementById("mobileJoystic").classList.remove("none");
        document.getElementById("moveBtn").classList.remove("none");
        this.viewer.image.removeAttribute("style")
        this.player.stop();
        // if (!document.getElementById("popup-painting").classList.contains('active')) {
        if (!document.getElementById("popup-painting").classList.contains('active')) {
          setTimeout(() => {
            document.getElementById("mainOptWrap").classList.remove("none");
          }, 70)
        }
        // }
      },
    );
    this.raycaster = new Raycaster(
        new Vector3(),
        new Vector3(0, -1, 0),
        0,
        100
    );
    this.orbit.update();
    setInterval(() => {
      // this.mobPortal();
    })
  }

  onTouch(event) {
    this.viewer.tutorialSwitch = false;
    // this.mobPortal();
    this.mouse.x =
      +(event.changedTouches[0].pageX / this.viewer.container.offsetWidth) * 2 +
      -1;
    this.mouse.y =
      -(event.changedTouches[0].pageY / this.viewer.container.offsetHeight) *
        2 +
      1;

    this.frontRay.setFromCamera(this.mouse, this.viewer.camera);
    this.intersects = this.frontRay.intersectObjects(this.viewer.meshOnScene);

      if (config[this.intersects[0].object.name]) {
        if (document.getElementById("select-language-mobile").value === "En") {
          this.viewer.tutorialMob.classList.add('none');
          document.getElementById("mobileJoystic").classList.add("none");
          document.getElementById("moveBtn").classList.add("none");
          document.getElementById("mainOptWrap").classList.add("none");
          this.data = config[this.intersects[0].object.name];
        } else {
          // this.data = configrus[this.intersects[0].object.name];
        }
        this.painting = document.getElementById("popup-painting");
        this.painting.classList.add("active");

        let link = [];
        let temp0 = "";
        this.data.link.forEach((item, index) => {
          link.push(item);
        });
        this.data.description.forEach((item, index) => {
          if (index === 0) {
            temp0 += "<div class='descDiv'>" + item + "</div>";
          }
          // else {
          //   temp0 += "<a target='_blank' class='descDivLink'>" + item + "</a>";
          // }
        });
        this.data.pointerDesc.forEach((item, index) => {
          temp0 += "<a target='_blank' class='descDivLink'>" + item + "</a>";
        })
        document.getElementById("painting__desc").innerHTML = temp0;
        const elements = document.querySelectorAll(".descDivLink");
        elements.forEach((i, index) => {
          i.href = link[index];
        })

        document.getElementById("painting__img").style.backgroundImage =
            "url(" + this.paintings[this.data.painting] + '.default' + ")";
        document.getElementById("painting__mobile").src =
            this.paintings[this.data.smallPainting].default;
      }
  }

  onTouch2(direction) {
    // this.frontRay.ray.set(camera.position, direction);
    // const intersects = this.frontRay.intersectObjects(this.viewer.meshOnScene);
    // if (intersects[0]) {
    //   return intersects[0].distance < 1 ? false : true;
    // } else {
    //   return true;
    // }

    this.raycaster.ray.origin.copy(this.orbit.position0);
    let intersections = this.raycaster.intersectObjects(
        this.viewer.meshOnScene
    );
    this.frontRay.ray.set(camera.position, direction);
    const intersects = this.frontRay.intersectObjects(this.viewer.meshOnScene);
    if (intersections[0].object.name === "floor_nav" && intersects[0].distance >= 1) {
      return true
    } else {
      return false;
    }
  }

  updatePlayer() {

    const angle = this.orbit.getAzimuthalAngle();

    if (fwdValue > 0) {
      tempVector.set(0, 0, -fwdValue).applyAxisAngle(upVector, angle);
      if (this.onTouch2(tempVector)) {
        camera.position.addScaledVector(tempVector, 0.05);
        this.orbit.target.addScaledVector(tempVector, 0.05);
      }
    }

    if (bkdValue > 0) {
      tempVector.set(0, 0, bkdValue).applyAxisAngle(upVector, angle);
      if (this.onTouch2(tempVector)) {
        camera.position.addScaledVector(tempVector, 0.05);
        this.orbit.target.addScaledVector(tempVector, 0.05);
      }
    }

    if (lftValue > 0) {
      tempVector.set(-lftValue, 0, 0).applyAxisAngle(upVector, angle);
      if (this.onTouch2(tempVector)) {
        camera.position.addScaledVector(tempVector, 0.05);
        this.orbit.target.addScaledVector(tempVector, 0.05);
      }
    }

    if (rgtValue > 0) {
      tempVector.set(rgtValue, 0, 0).applyAxisAngle(upVector, angle);
      if (this.onTouch2(tempVector)) {
        camera.position.addScaledVector(tempVector, 0.05);
        this.orbit.target.addScaledVector(tempVector, 0.05);
      }
    }
  }

  addJoystick() {
    let options = {
      zone: document.getElementById("mobileJoystic"),
      mode: "static",
      position: { left: "85px", bottom: "4%" },
      color: "#C8C8C8",
    };
    joyManager = nipplejs.create(options);

    joyManager["0"].on("move", function (evt, data) {
      const forward = data.vector.y;
      const turn = data.vector.x;

      if (forward > 0) {
        fwdValue = Math.abs(forward);
        // console.log(fwdValue)
        bkdValue = 0;
      } else if (forward < 0) {
        fwdValue = 0;
        bkdValue = Math.abs(forward);
        // console.log(bkdValue)
      }

      if (turn > 0) {
        lftValue = 0;
        rgtValue = Math.abs(turn);
        // console.log(rgtValue)
      } else if (turn < 0) {
        lftValue = Math.abs(turn);
        // console.log(lftValue)
        rgtValue = 0;
      }
    });

    joyManager["0"].on("end", function (evt) {
      bkdValue = 0;
      fwdValue = 0;
      lftValue = 0;
      rgtValue = 0;
    });
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 2000)
  }
}
